// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'; // Import Provider
import { GoogleOAuthProvider } from '@react-oauth/google';
import store from './store'; // Import Redux store
import App from './App';

// Disable browser spell checking globally
if (typeof document !== 'undefined') {
    document.body.setAttribute('spellcheck', 'false');
}

ReactDOM.render(
    <Provider store={store}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <App />
        </GoogleOAuthProvider>
    </Provider>,
    document.getElementById('root')
);